import { logger } from "./logger";

export const setupRedditPixel = () => {
  const searchParams = new URLSearchParams(window.location.search);
  let utmSource = searchParams.get("utm_source");

  if (!utmSource) {
    try {
      utmSource = localStorage.getItem("utm_source");
    } catch (e) {
      logger.debug(`Error accessing localStorage for utm_source: ${String(e)}`);
    }
  }

  if (utmSource !== "reddit") {
    logger.debug("Reddit Pixel not initialized: utm_source is not reddit.");
    return;
  }

  const redditScript = `!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt('init','a2_i4iw72d7a456');rdt('track', 'PageVisit');`;

  const script = document.createElement("script");
  script.innerHTML = redditScript;
  script.async = true;
  document.head.appendChild(script);
};

export function sendInitKeysToRedditPixel(utmSource: string | null) {
  try {
    if (!(window as any).rdt) {
      console.error(`Reddit Pixel not initialized yet.`);
      logger.debug(`Reddit Pixel not initialized yet.`);
      return;
    }

    (window as any).rdt("track", "Purchase", {
      currency: "USD",
      value: 1.99,
      item_id: utmSource === "reddit" ? "Purchase" : "start_trial",
    });
  } catch (error) {
    console.error("Reddit Pixel Error:", error);
  }
}
